import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  button: {
    color: "white",
    position: "absolute",
    bottom: 0,
    right: 0,
    "border-radius": 5,
    padding: [8, 30],
    "font-size": 16,
    border: "none",
    cursor: props => (props.disabled ? "not-allowed" : "pointer"),
    "background-color": props => (props.disabled ? "#ccc" : "#ff0050"),
    transition: "background-color 0.1s ease",
  },
});

const RedButton = ({ disabled = false, ...props }) => {
  const classes = useStyles({ disabled });

  return <button className={classes.button} disabled={disabled} {...props} />;
};

export default RedButton;
